import React from "react";
import { useAuth } from "../../lib/auth";
import { SignOut, User as UserIcon } from "@phosphor-icons/react";
import DutyWidget from "./DutyWidget";
import ChatBell from "./ChatBell";
import TicketBell from "./TicketBell";
import CustomerTicketAlarm from "./CustomerTicketAlarm";
import NotificationBell from "./NotificationBell";
import ArmSwitcher from "./ArmSwitcher";

export default function Topbar({ title, subtitle, actions }) {
  const { user, logout } = useAuth();
  return (
    <header
      data-testid="topbar"
      className="bg-white border-b border-[#E5E2D9] px-8 py-4 sticky top-0 z-30 flex items-center justify-between gap-6"
    >
      <div>
        <div className="text-[11px] uppercase tracking-[0.2em] text-[#8A8780]">
          Rescigo Admin / {subtitle || "Control Panel"}
        </div>
        <h1 className="font-heading text-2xl sm:text-3xl tracking-tight text-[#1A1A1A] mt-0.5">
          {title}
        </h1>
      </div>
      <div className="flex items-center gap-3">
        {user && <ArmSwitcher />}
        {actions}
        <DutyWidget user={user}/>
        {user && <ChatBell />}
        {user && <TicketBell />}
        {user && <CustomerTicketAlarm />}
        {user && <NotificationBell />}
        {user && (
          <div className="flex items-center gap-3 pl-4 border-l border-[#E5E2D9]">
            <div className="text-right">
              <div className="text-sm font-medium text-[#1A1A1A]" data-testid="user-name">
                {user.name}
              </div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-[#8A8780]">
                {user.role}
              </div>
            </div>
            <div className="w-10 h-10 rounded-full bg-[#D4E0D1] flex items-center justify-center">
              <UserIcon size={20} color="#2D5A27" weight="fill" />
            </div>
            <button
              data-testid="logout-btn"
              onClick={logout}
              className="p-2 rounded-md text-[#5C5A55] hover:text-[#C25D38] hover:bg-[#F7F6F2] transition-colors"
              title="Logout"
            >
              <SignOut size={18} />
            </button>
          </div>
        )}
      </div>
    </header>
  );
}
